module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsTAAALEwEAmpwYAAABKUlEQVQokXXSvS9lURQF8B+uTJBMRIfESHw0CiLR+YwppxdCxmSSVyipeaiEqChUk2mmofQHaHU0OsUk8jIFU5hGHp6ruFtyXWYnJzk7+6y19l771JVKJbnoxCo+ow5VnGAd1y+PkgLgF4ZwhAo+4Tt6sYg/eVADvmIcSzjIkV1gB3PYhfoofMQXXIZKPvbwN1TlQbXouQWtBVA3mvBYBP3DT7RjBcPBPBImPMkMeWPEMTZjpukwogvNWI76KyXoj9ZqcZ9CT+QDmCgqzaOMNpzhNGoPMecMFrCN7QST2McVZmUOVpHKFtwYZFtxbpIY9DaYzr0fv/ENh9ioR18M+T/AS1TwAx2JzM4x2RLvZPtIwqQ0l3/AIGoJ1mT/azQKaUEhDYJH3KP8DMc8QaQ6SPNBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/user.png
// module id = tLud
// module chunks = 3